/** A quiet loading indicator, announced to screen readers as busy. */
export function Spinner({ className = '', label = 'Loading' }) {
  return (
    <span role="status" aria-label={label} className={`inline-flex ${className}`}>
      <span
        aria-hidden="true"
        className="size-5 animate-spin rounded-full border-2 border-ink-3 border-t-transparent"
      />
    </span>
  );
}
